// Validações puras reutilizáveis (testáveis sem DOM nem BD).

// Valida um número de telefone:
// - Português sem prefixo: 9[1236]XXXXXXX (com ou sem +351 / 00351 / 351)
// - Internacional: começa com + seguido de código de país e pelo menos 7 dígitos
export function validarTelefone(tel) {
  if (!tel) return false
  const limpo = tel.replace(/[\s\-().]/g, '')
  // Internacional com +: aceita qualquer +XX... com 7 a 15 dígitos no total
  if (limpo.startsWith('+')) return /^\+\d{7,15}$/.test(limpo)
  // Português: 00351 / 351 / 9XXXXXXXX
  const digits = limpo.replace(/^00351|^351/, '')
  return /^9[1236]\d{7}$/.test(digits)
}

// Normaliza um número de telefone para formato E.164 (+XXXXXXXXXXX).
// 00XX... → +XX..., 351XXXXXXXXX → +351..., 9XXXXXXXX → +351...
// Números estrangeiros sem 00 ou + não são alterados (ambíguos).
export function normalizarTelefone(tel) {
  if (!tel) return tel
  let limpo = tel.replace(/[\s\-().]/g, '')
  if (limpo.startsWith('00')) limpo = '+' + limpo.slice(2)
  if (!limpo.startsWith('+')) {
    if (/^9\d{8}$/.test(limpo)) limpo = '+351' + limpo
    else if (limpo.startsWith('351')) limpo = '+' + limpo
  }
  return limpo
}
